const ProjectSpecializTransportation = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Project Specialised Transportation
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS special transport equipment and experienced specialists are able to execute projects involving various 
              loads, such as wind turbines, construction and agricultural equipment, mining, oil and gas structures and 
              recipients, transformers, generators, gas turbines, and more.  
            </p>
           
          </div>
          <div className="flex-1 flex flex-col justify-center items-center lg:mt-[0rem] mt-[1rem]">
            <img src="/fleet-transportation/Project-Specialized-Transportation-Inside.jpg" alt="" className="rounded-md w-[100%]"/>
          </div>
        </ div>

      </div>

    </div>
  );
};
  
export default ProjectSpecializTransportation;
  